// eslint-disable-next-line
export const regexWebsite =/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/

export const isValidWebsite = (input) => {
    return regexWebsite.test(String(input).toLowerCase())
}
